import usePage from '../../hooks/usePage';

import Blocks from '../blocks/Blocks';
import PageTitle from '../partials/PageTitle';

import styles from '../../../styles/pages/page-default.module.scss';

function PageDefault() {
    const { page = null } = usePage();
    const { title = 'Page', blocks } = page || {};
    return (
        <div className={styles.container}>
            <PageTitle className={styles.title} title={title} />
            <Blocks blocks={blocks} isContainer />
        </div>
    );
}

export default PageDefault;
